var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNhsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 27,
    viewBox: "0 0 68 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1661 0V27H0.166077V0H67.1661ZM22.4794 24.34L27.1459 2.61H21.6001L18.5324 17.68H18.4724L13.9958 2.61H6.72118L2.05467 24.34H7.60053L10.5983 9.34H10.6582L15.2248 24.34H22.4794ZM47.9005 2.61L43.3339 24.34H37.4882L39.4268 15H32.5119L30.5734 24.31H24.7277L29.2644 2.58H35.14L33.4213 10.89H40.3261L42.0448 2.58L47.9005 2.61ZM64.6892 3.22692L64.6979 3.2V3.23C64.695 3.22897 64.6921 3.22794 64.6892 3.22692ZM63.289 7.53L64.6892 3.22692C62.544 2.47257 60.2747 2.13422 58.0029 2.23C53.2165 2.23 48.2802 3.91 48.2802 9.52C48.2802 13.0138 51.0328 14.0908 53.4003 15.017C55.1867 15.716 56.7538 16.3291 56.7538 17.83C56.7538 20.07 53.906 20.42 52.0973 20.42C50.2299 20.4519 48.3834 20.0225 46.7213 19.17L45.3424 23.59C47.5307 24.2771 49.8045 24.6541 52.0973 24.71C57.1635 24.71 62.7594 23.15 62.7594 17.15C62.7594 13.2287 59.7682 12.0432 57.3402 11.0808C55.6816 10.4233 54.2857 9.87008 54.2857 8.62C54.2857 6.87 56.1643 6.53 58.4726 6.53C60.1329 6.49494 61.7796 6.83683 63.289 7.53Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNhsLogo);
export default __webpack_public_path__ + "static/media/nhs-logo.51d97de72bdb875f4d5bdc4baeead61c.svg";
export { ForwardRef as ReactComponent };